<template>
<v-tooltip top>
  <template v-slot:activator="{ on, helpInstruction }">
    <v-icon
      small
      v-bind="helpInstruction"
      v-on="on"
    >mdi-help-circle</v-icon>
  </template>
  <span class="form-instruction-text">{{ formInstruction( 'poll-data-photos' ) }}</span>
</v-tooltip>
</template>


<script>
import getFormInstruction from '@/const/form/formInstructionHelper.js';

export default {
  name: 'FormFieldHelper',
  methods: {
    formInstruction: getFormInstruction,
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/formField/helper/FormFieldHelper.vue